export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "http://router.default.svc.cluster.local/api/graphql/", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}